// const apiService = 'http://localhost:5050/api';
const apiService = 'https://gymkhana.iitkgp.ac.in/api';

export default apiService;
